<loading-animation *ngIf="!isReady" size="large"></loading-animation>

<div class="control-container" *ngIf="isReady">
    <cas-header [primary]="currentControl.text" contrast="Schedule"></cas-header>

    <div>
        <dl-copy-to *ngIf="nonSelectedRtus.length" [currentHardwareId]="currentControl.id" [locationId]="locationId" [nonSelectedRtus]="nonSelectedRtus"></dl-copy-to>

        <rr-weekly-scheduler [adapter]="weeklySchedulerAdapter"
                             [hoverClass]="hoverClass"
                             [options]="weeklySchedulerOptions">
        </rr-weekly-scheduler>

        <dl-device-status-bar [autoShowOnChange]="currentControl.status.statusText" [status]="currentControl.status"></dl-device-status-bar>

        <div class="schedule-preview-container" *ngFor="let setpoint of setpoints">
            <dl-setpoint class="schedule-preview" [setpointModel]="setpoint" titlePrefix="Click to Edit:" (click)="editSetpoint(setpoint)" (onMouseEnter)="setHoverClass(setpoint)" (onMouseLeave)="setHoverClass()" [useThemeColors]="true"></dl-setpoint>
        </div>
    </div>
</div>
